const handleBodyClick = function (e) {
  const { target } = e;

  if (target !== this && !target.closest('section-header')) {
    // e.preventDefault();

    const mobileNav = this.el ? null : this.querySelector('.header__inline-menu');

    if (mobileNav) {
      this.close();
    } else {
      [...this.el.querySelectorAll('.subnav[open]')].forEach(subnav => subnav.removeAttribute('open'));
    }

    document.body.removeEventListener('click', handleBodyClick.bind(this));
  }
}

class SectionHeader extends HTMLElement {
  constructor() {
    super();
    this.mobileNavToggle = this.querySelector('.header-mobile__nav-trigger');
    this.mobileNav = this.querySelector('.header__inline-menu');

    this.mobileNavToggle.addEventListener(
      'click',
      this.onMobileNavToggleClick.bind(this)
    );
  }

  onMobileNavToggleClick(event) {
    event.preventDefault();
    this.mobileNav.hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.mobileNav.setAttribute('open', true);
    this.mobileNavToggle.innerText = 'close';
    document.body.classList.add('overflow-hidden');
    document.body.addEventListener('click', handleBodyClick.bind(this));
  }

  close() {
    this.mobileNav.removeAttribute('open');
    this.mobileNav.querySelectorAll('.subnav').forEach(el => el.style = '')
    this.mobileNavToggle.innerText = 'menu';
    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', handleBodyClick.bind(this));
  }
}

customElements.define('section-header', SectionHeader);


class SlideRight {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.subnav = el.querySelector('.subnav');
    this.closeButton = [...el.querySelectorAll('.close')].slice(-1)[0];

    this.summary.addEventListener('click', event => this.onClick(event));
    this.closeButton.addEventListener('click', event => this.close(event));


    // Close nav on click outside of nav WIP

    // if (el.querySelector('.subnav[open]')) {
    //   console.log('document click');
    //   document.addEventListener('click', event => {
    //     console.log('document click');
    //     if (event.target !== el.querySelector('.subnav[open]')[0]){
    //       el.querySelector('.subnav[open]')[0].removeAttribute('open')
    //     }
    //   });
    // }
  }
  onClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.el.open) {
      this.open(event);
    } else {
      this.close(event);
    }
  }
  open(event) {
    event.target.setAttribute('aria-expanded', true);
    this.subnavsToClose = event.target.closest('.subnav') ? [...event.target.closest('.subnav').querySelectorAll('.subnav')] : []
    this.subnavsToClose.forEach(subnav => subnav.removeAttribute('open'));
    this.el.querySelector('.subnav').setAttribute('open', true);

    document.body.addEventListener('click', handleBodyClick.bind(this));
  }
  close(event) {
    this.subnavsToClose = [...event.target.closest('.subnav').querySelectorAll('.subnav')];
    this.subnavsToClose.push(event.target.closest('.subnav'));
    this.subnavsToClose.forEach(subnav => {
      subnav.previousElementSibling.setAttribute('aria-expanded', false);
      subnav.removeAttribute('open')
    });

    document.body.removeEventListener('click', handleBodyClick.bind(this));
  }
}

document.querySelectorAll('section-header .hasSubNav').forEach((el) => {
  new SlideRight(el);
});
